import React, { useState, useRef } from 'react';

import Page from '../common/Page';
import { Question } from '../common/Text';
import { ImageTextButton } from '../common/Button';

import emotionHappy from '../../assets/emotion_happy.svg'
import emotionThankful from '../../assets/emotion_thankful.svg'
import emotionDepressed from '../../assets/emotion_depressed.svg'
import emotionSad from '../../assets/emotion_sad.svg'
import emotionWorried from '../../assets/emotion_worried.svg'
import emotionAngry from '../../assets/emotion_angry.svg'

export default function Emotion(props) {
    const [options, setOptions] = useState(props.options)
    const selected = useRef(false)

    const selectOption = (index) => (e) => {
        e.preventDefault();  
        if (selected.current) {
            return;
        }
        
        selected.current = true;      
        setOptions(options.map((option, i) => {
            if (index === i) {
                option.selected = true;
                return option;
            } else {
                return option;
            }            
        }))
        
        props.saveResult(options[index].text);
        props.nextStep();
    }
          
    return (
        <Page>                
            <Question style={{marginBottom: '2rem'}}>
                How do you feel right now?
            </Question>                                      
            {
                options.map((option, index) => {                
                    return (
                        <ImageTextButton  
                            selected={option.selected}
                            key={index}                       
                            index={index}                                                    
                            imageSrc={option.imageSrc}                            
                            onClick={selectOption(index)}
                        >
                            {option.text}
                        </ImageTextButton>
                    )
                })
            }                                            
        </Page>
    )    
}

Emotion.defaultProps = {
    options: [
        { 
            imageSrc: emotionHappy,
            text: 'Happy',
            selected: false
        },
        { 
            imageSrc: emotionThankful,
            text: 'Thankful',
            selected: false
        },
        { 
            imageSrc: emotionDepressed,
            text: 'Depressed',
            selected: false
        },
        { 
            imageSrc: emotionSad,
            text: 'Sad',
            selected: false
        },
        { 
            imageSrc: emotionWorried,
            text: 'Worried',
            selected: false
        },
        { 
            imageSrc: emotionAngry,
            text: 'Angry',
            selected: false
        }
    ]
}